module.exports = __webpack_public_path__ + "static/3-aa718c82aad0e47f6e7a8dd06c6949e9.png";